import React from 'react';

import DelegationsPanel from '../delegations/DelegationsPanel';

// Faz J'nin Vekâletler sekmesi. Gövde platforma taşındı (bkz. pages/delegations) çünkü
// vekâlet artık Performans'a ait değil: teklif onay zinciri de aynı kaydı kullanıyor ve
// PM'e abone olmayan kiracılar da vekâlet kurabilmeli.
//
// Sekme KAPSAMINI SABİTLER: burada yalnız Performans vekâletleri listelenir ve yalnız
// Performans vekâleti kurulur. Sekmenin adı "Performans Ayarları"nın altında durduğu için
// başka bir yüzeyin vekâletini buradan kurmak (ya da burada görmek) yanıltıcı olurdu.
export default function DelegationsTab() {
  return <DelegationsPanel lockedScope="performance" />;
}
